import { ControlledInput } from 'modules/common/components';
import RegionSelect from 'modules/locations/components/RegionSelect';
import { Control, FormState } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

import { IAddOfficeFormSchema } from './schema';

export enum AddOfficeFormField {
  Name = 'name',
  zoetisAccountNumber = 'zoetisAccountNumber',
  idexxAccountNumber = 'idexxAccountNumber',
  regionId = 'regionId',
}

type ParamType = {
  control: Control<IAddOfficeFormSchema, any>;
};
type FormErrorsType = FormState<IAddOfficeFormSchema>['errors'];

const t = getTranslation('user.CreateLocationsForm');

export const getFormFields = (params: ParamType) => {
  const { control } = params;
  const createOfficeFormFields = [
    {
      name: AddOfficeFormField.Name,
      getErrorMessage: (errors: FormErrorsType) => errors.name?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('enterOfficeName')}
          controlled={{
            control,
            name: AddOfficeFormField.Name,
          }}
        />
      ),
    },
    {
      name: AddOfficeFormField.idexxAccountNumber,
      getErrorMessage: (errors: FormErrorsType) =>
        errors.idexxAccountNumber?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('idexxAccountNumber')}
          controlled={{
            control,
            name: AddOfficeFormField.idexxAccountNumber,
          }}
        />
      ),
    },
    {
      name: AddOfficeFormField.zoetisAccountNumber,
      getErrorMessage: (errors: FormErrorsType) =>
        errors.zoetisAccountNumber?.message,
      Component: () => (
        <ControlledInput
          placeholder={t('zoetisAccountNumber')}
          controlled={{
            control,
            name: AddOfficeFormField.zoetisAccountNumber,
          }}
        />
      ),
    },
    {
      name: AddOfficeFormField.regionId,
      getErrorMessage: (errors: FormErrorsType) => errors.regionId?.message,
      Component: () => (
        <RegionSelect
          controlled={{
            control,
            name: AddOfficeFormField.regionId,
          }}
        />
      ),
    },
  ];
  return createOfficeFormFields;
};
